'use client'

import { useEffect, useState } from 'react'

export function LocalDateTime({
  value,
  prefix,
  fallback = '—',
}: {
  value?: string
  prefix?: string
  fallback?: string
}) {
  const [label, setLabel] = useState<string | null>(null)

  useEffect(() => {
    if (!value) {
      setLabel(fallback)
      return
    }
    const date = new Date(value)
    if (Number.isNaN(date.getTime())) {
      setLabel(value)
      return
    }
    setLabel(date.toLocaleString('ru-RU', {
      day: 'numeric',
      month: 'short',
      hour: '2-digit',
      minute: '2-digit',
    }).replace('.', ''))
  }, [fallback, value])

  return (
    <span title="Время в вашем часовом поясе">
      {prefix}{label ?? fallback}
    </span>
  )
}
